import { Component, Input } from '@angular/core';
import { UserProcessMode } from '@interfaces';

@Component({
  selector: 'app-user-process-mode-pill',
  templateUrl: './user-process-mode-pill.component.html',
  styleUrls: ['./user-process-mode-pill.component.scss'],
  standalone: false,
})
export class UserProcessModePillComponent {
  @Input() mode: UserProcessMode;
  @Input() iconOnly = false;

  public readonly UserProcessMode = UserProcessMode;

  public get modeIcon(): string {
    return this.mode === UserProcessMode.MOS ? 'account_balance' : 'local_post_office';
  }
}
